import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { WhatsIncluded } from './components/WhatsIncluded';
import { WhoItsFor } from './components/WhoItsFor';
import { Guarantee } from './components/Guarantee';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
import { initMetaPixel } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-text selection:bg-brand-mint/30" data-id="element-0" data-mp="2mnne1xqjvzy4">
      <Hero data-id="element-1" data-mp="31ctfztgrw49p" />
      <PainPoints data-id="element-2" data-mp="31cjk5p91r2w3" />
      <Solution data-id="element-3" data-mp="2wjgqlh49rtfw" />
      <WhatsIncluded data-id="element-4" data-mp="2wjqkvgwckmre" />
      <WhoItsFor data-id="element-5" data-mp="2wiffxdr618yp" />
      <Guarantee data-id="element-6" data-mp="2whx95n6vnccj" />
      <Pricing data-id="element-7" data-mp="28ufpyg1ohml6" />
      <Footer data-id="element-8" data-mp="28tw62tsgwo4i" />
    </div>;
}